export default {"src":"/catalog/_next/static/media/ChevronUp.935bb09f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};